import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '@/auth/services';
import {
    DataTableComponent,
    FilePreviewComponent
} from '@/components';
import {
    DataTableColumnType,
    FilterType
} from '@/enums';
import {
    DataTableColumn,
    Document
} from '@/interfaces';
import { DocumentsService } from '@/service';

@Component({
    selector: 'app-document-listing',
    standalone: true,
    templateUrl: 'listing.component.html',
    imports: [DataTableComponent],
})
export class DocumentListingComponent {

    reloadTable$ = new Subject<void>();
    columns: DataTableColumn<Document>[] = [
        {
            field: 'source_file',
            header: 'Document',
            type: DataTableColumnType.MODAL,
            modalComponent: FilePreviewComponent,
            modalTitle: 'View Document',
            modalData: (row: Document) => ({ url: row.source_file_url }),
            modalBtnDisabled: (row: Document) => !row.source_file_url,
        },
        {
            field: 'district_name',
            header: 'School District',
            filterType: FilterType.AUTOCOMPLETE,
            autocompleteCompleteMethod: (q, context) => this.documentAutocomplete('district_name', q, context),
        },
        {
            field: 'year',
            header: 'Year',
            filterType: FilterType.SELECT,
            filterOptionsFn: (context) => this.service.options(context).pipe(
                map(o => (o.years ?? []).map(v => ({ label: String(v), value: v })))
            ),
        },
        {
            field: 'providers',
            header: 'Competitor Mapped',
            type: DataTableColumnType.ARRAY
        },
        {
            field: 'state',
            header: 'State',
            filterType: FilterType.MULTISELECT,
            filterOptionsFn: (context) => this.service.options(context).pipe(
                map(o => (o.states ?? []).map(v => ({ label: v, value: v })))
            )
        },
        {
            field: 'county',
            header: 'County',
            filterType: FilterType.SELECT,
            filterOptionsFn: (context) => this.service.options(context).pipe(
                map(o => o.counties.map(v => ({ label: v, value: v })))
            )
        },
    ];

    constructor(
        public authService: AuthService,
        private service: DocumentsService,
    ) {
    }

    loadData = (params: Record<string, any>) => this.service.listing(params);

    exportData = (params: Record<string, any>) => this.service.export(params);

    documentAutocomplete(field: 'district_name', query: string, context: Record<string, any> = {}) {
        return this.service.autocomplete(field, query, context).pipe(map((res) => res.data ?? res));
    }
}
